import { render } from "./ProductHeader.vue?vue&type=template&id=073b189c&scoped=true&ts=true"
import script from "./ProductHeader.vue?vue&type=script&lang=ts"
export * from "./ProductHeader.vue?vue&type=script&lang=ts"

import "./ProductHeader.vue?vue&type=style&index=0&id=073b189c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073b189c"]])

export default __exports__